<script setup>
  defineOptions({
    name: "MergeAccountSteps",
  });
</script>

<template>
  <ol class="mt-8 flex flex-col space-y-2 md:flex-row md:space-y-0 md:space-x-2 lg:space-x-4">
    <slot />
  </ol>
</template>
